/**
 * The three trading venues G1 shows side by side, with explicit labels (#987).
 *
 * Kalshi, international Polymarket and Polymarket US are independent venues.
 * Anything that renders a venue must look it up here rather than branching
 * `venue === 'kalshi' ? … : <Polymarket>`, which would silently present a US
 * row as international Polymarket.
 */
export type TradingVenue = 'kalshi' | 'polymarket' | 'polymarket_us';

export const VENUE_NAME: Record<TradingVenue, string> = {
  kalshi: 'Kalshi',
  polymarket: 'Polymarket',
  polymarket_us: 'Polymarket US',
};

export const VENUE_SHORT: Record<TradingVenue, string> = {
  kalshi: 'K',
  polymarket: 'P',
  polymarket_us: 'US',
};

/** One colour family per venue: Kalshi blue, Polymarket purple (VenueChip),
 * Polymarket US teal. A trader's eye separates venues by colour before it
 * reads the letter, so US must never share Polymarket's purple. */
export const VENUE_TONE: Record<TradingVenue, string> = {
  kalshi: 'bg-blue-500/20 text-blue-400',
  polymarket: 'bg-purple-500/20 text-purple-400',
  polymarket_us: 'bg-teal-500/20 text-teal-400',
};

/** Selected venue-tab style (Game Detail), same families as VENUE_TONE. */
export const VENUE_TAB_ACTIVE: Record<TradingVenue, string> = {
  kalshi: 'bg-blue-500/20 text-blue-300 light:text-blue-700 border-blue-500 border-b-2',
  polymarket: 'bg-purple-500/20 text-purple-300 light:text-purple-700 border-purple-500 border-b-2',
  polymarket_us: 'bg-teal-500/20 text-teal-300 light:text-teal-700 border-teal-500 border-b-2',
};

/** Book quantity column label. International Polymarket quotes shares. */
export const VENUE_QUANTITY_LABEL: Record<TradingVenue, string> = {
  kalshi: 'Contracts',
  polymarket: 'Shares',
  polymarket_us: 'Contracts',
};
